define('OutSystems/ClientRuntime/RequireManager',["require", "exports"], function (require, exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.configure = exports.loadModule = exports.setErrorHandler = exports.initialize = void 0;
    var BUNDLE_SEPARATOR_CHAR = "$";
    function initialize() {
        ensureInitialized();
    }
    exports.initialize = initialize;
    function ensureInitialized() {
        ensureContextsArePatched();
    }
    function setErrorHandler(handler) {
        requirejs.onError = handler;
    }
    exports.setErrorHandler = setErrorHandler;
    function loadModule(moduleNames, onReady, onError) {
        requirejs(moduleNames, onReady, onError);
    }
    exports.loadModule = loadModule;
    function configure(scriptMap, defaultScriptsDir) {
        if (defaultScriptsDir === void 0) { defaultScriptsDir = "scripts"; }
        var requireJsConfig = { baseUrl: defaultScriptsDir, paths: {}, waitSeconds: 30 };
        if (scriptMap) {
            for (var js in scriptMap) {
                if (requirejs.specified(js) || requirejs.defined(js)) {
                    delete scriptMap[js];
                }
            }
            requireJsConfig.paths = scriptMap;
        }
        requirejs.config(requireJsConfig);
        ensureInitialized();
    }
    exports.configure = configure;
    function ensureContextsArePatched() {
        var contexts = requirejs.s.contexts;
        Object.keys(contexts).forEach(function (key) {
            var context = contexts[key];
            if (!context._osNameToUrlPatched) {
                var oldNameToUrl_1 = context.nameToUrl;
                context.nameToUrl = function (moduleName, ext, skipExt) {
                    if (moduleName.indexOf(BUNDLE_SEPARATOR_CHAR) > 0 && moduleName.indexOf("?") === -1) {
                        moduleName = moduleName.split(BUNDLE_SEPARATOR_CHAR, 2)[0];
                    }
                    return oldNameToUrl_1.apply(context, [moduleName, ext, skipExt]);
                };
                context._osNameToUrlPatched = true;
            }
        });
    }
});
//# sourceMappingURL=RequireManager.js.map;
